(function() {
  var searchSuggestions = [
    "Tourniquets for bleeding control...",
    "IFAK kits and trauma supplies...",
    "Chest seals and airway devices...",
    "Hemostatic gauze and agents...",
    "Tactical medical backpacks...",
    "Body armor and plate carriers...",
    "Stop the Bleed kits...",
    "Medical pouches and organizers...",
    "Emergency bandages and dressings...",
    "Splint and SAM splints...",
    "Needle decompression kits...",
    "NAR products and supplies..."
  ];
  
  var currentSuggestion = 0;
  var searchInput = document.querySelector('.header-search-input[data-rotate-placeholder]');
  
  if (searchInput) {
    currentSuggestion = Math.floor(Math.random() * searchSuggestions.length);
    searchInput.placeholder = searchSuggestions[currentSuggestion];
    searchInput.classList.add('rotating');
    
    var _searchRotator = null;
    function startSearchRotation() {
      if (_searchRotator) return;
      _searchRotator = setInterval(function() {
        if (document.activeElement === searchInput) return;
        if (document.hidden) return;
        
        searchInput.classList.add('fade-out');
        
        setTimeout(function() {
          currentSuggestion = (currentSuggestion + 1) % searchSuggestions.length;
          searchInput.placeholder = searchSuggestions[currentSuggestion];
          searchInput.classList.remove('fade-out');
        }, 300);
      }, 4000);
    }
    function stopSearchRotation() {
      if (_searchRotator) { clearInterval(_searchRotator); _searchRotator = null; }
    }
    var _searchVisObs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) startSearchRotation();
      else stopSearchRotation();
    }, { threshold: 0 });
    _searchVisObs.observe(searchInput);
    startSearchRotation();
  }
})();
